import {getData, LOGIN} from "../../storage";
import {isEmpty} from "../../utility";
import assets from "../../assets";
import strings from "../../strings";
import api from "../broadcaster/library";

const getSubscriptionListAPI = (props) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getSubscriptionList(
                    data.token,
                    data.api_token,
                );
            }
        })
}

const cancelSubscriptionAPI = (props, id = null,broadcaster_id = -1) => {

    const payload = {
        image: assets.broadcaster.profile.subscribe_active,
        title: strings.clipstore.broadcaster.cancel_subscription.title,
        description: strings.clipstore.broadcaster.cancel_subscription.description
    };
    const isConfirmationModal = true;
    const actionArray = [{
        text: "NO",
        click: () => {
            console.log("Clicked on CANCEL");
            props.hideCommonModal()
        }
    }, {
        text: "YES",
        click: () => {
            console.log("Clicked on OK")
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        props.cancelSubscription(
                            data.token,
                            data.api_token,
                            id,
                            broadcaster_id
                        );
                    }
                })
        }
    }];

    props.showCommonModal(payload, isConfirmationModal, actionArray);
}

const renewSubscriptionAPI = (props, id) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.renewSubscription(
                    data.token,
                    data.api_token,
                    id
                );
            }
        })
}

export default {
    getSubscriptionListAPI,
    cancelSubscriptionAPI,
    renewSubscriptionAPI
}